<template>
    <v-dialog
        v-model="innerValue"
        v-bind="$attrs"
        max-width="600"
    >
        <v-card :loading="loading && 'white'">
            <v-toolbar
                color="primary"
                dark
                flat
            >
                <v-toolbar-title>
                    Customize your code
                </v-toolbar-title>
            </v-toolbar>

            <v-container>
                <v-card-text>
                    <v-form ref="form">
                        <v-text-field
                            v-model="referralCode"
                            v-validate="'required|alpha_dash'"
                            name="referralCode"
                            :disabled="loading"
                            label="Referral Link"
                            color="primary"
                            :error-messages="errors.first('referralCode')"
                            outlined
                            required
                            @input="updateValidationErrors"
                        />
                    </v-form>
                </v-card-text>
            </v-container>

            <v-card-actions
                class="justify-space-around"
            >
                <v-btn
                    color="red darken-2 white--text"
                    text
                    @click="innerValue = false"
                >
                    Cancel
                </v-btn>

                <v-btn
                    color="primary white--text"
                    :loading="loading"
                    depressed
                    @click="updateReferralCode"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data: () => ({
            loading: false,
            referralCode: '',
        }),
        computed: {
            innerValue: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                },
            },
        },
        mounted() {
            this.referralCode = this.$_user.referral_code || '';
        },
        methods: {
            async updateReferralCode() {
                try {
                    this.loading = true;

                    const payload = {
                        referral_code: this.referralCode,
                    };

                    const { data } = await Vue.backendApi()
                        .user(this.$store.state.user.id)
                        .storeUser(payload);

                    this.$store.commit('storeUser', data);

                    this.$swal({
                        type: 'success',
                        title: 'Referral code successfully updated!',
                    });

                    this.innerValue = false;
                } catch (error) {
                    this.errors.add({
                        field: 'referralCode',
                        msg: error,
                    });

                    this.$validator.flag('referralCode', {
                        changed: false,
                    });
                } finally {
                    this.loading = false;
                }
            },

            /**
             * Remove all errors when value changed
             * for the first time after trying to save
             */
            updateValidationErrors() {
                if (!this.fields.referralCode.changed) {
                    this.errors.remove('referralCode');
                }
            },
        },
    };
</script>
